export type AdminInferenceValue = 'Yes' | 'Empty';

export interface AdvancedDirectiveSettings {
  _id?: string;
  regionId: number;
  dnrOnly_intubation: AdminInferenceValue;
  dniOnly_cpr: AdminInferenceValue;
  updatedBy?: { userName?: string };
  updatedAt?: string;
}

export const ADMIN_INFERENCE_OPTIONS: { id: AdminInferenceValue; label: string }[] = [
  { id: 'Empty', label: 'Empty' },
  { id: 'Yes', label: 'Yes' },
];
